// 吃瓜资讯 - 事件专题模拟数据
// 用于静态展示首页聚合与单篇深度解析页

export interface TimelineItem {
  time: string;
  title: string;
  text: string;
}

export interface AnalysisPoint {
  title: string;
  text: string;
}

export interface ChiguaEvent {
  id: string;
  title: string;
  hotTitle: string;
  category: string;
  tag: string;
  heat: number;
  views: string;
  comments: string;
  published: string;
  readingMin: number;
  author: string;
  excerpt: string;
  cover: string;
  lead: string;
  overview: string[];
  timeline: TimelineItem[];
  analysis: AnalysisPoint[];
  truthTitle: string;
  truthText: string[];
  conclusion: string;
}

export const categories = [
  { key: "全部", icon: "ri-fire-line" },
  { key: "娱乐圈", icon: "ri-star-smile-line" },
  { key: "饭圈观察", icon: "ri-heart-3-line" },
  { key: "综艺内幕", icon: "ri-tv-2-line" },
  { key: "网红塌房", icon: "ri-smartphone-line" },
  { key: "商界八卦", icon: "ri-building-4-line" },
  { key: "社会热议", icon: "ri-earth-line" },
];

export const EVENTS: ChiguaEvent[] = [
  {
    id: "chen-cheng-contract",
    title: "选秀新星“程澈”解约风波：从一夜爆红到深夜决裂的 21 天",
    hotTitle: "程澈解约风波全记录",
    category: "娱乐圈",
    tag: "合约纠葛",
    heat: 98,
    views: "286万",
    comments: "3.4万",
    published: "2026-09-06",
    readingMin: 12,
    author: "事件梳理组",
    excerpt:
      "一部综艺把人送上巅峰，一份声明把人推下神坛。程澈与经纪公司的解约事件，在 21 天内经历了蜜月、对峙、爆料到官宣的完整起伏，堪称年度教科书级瓜局。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20backstage%20spotlight%20glowing%20on%20an%20empty%20concert%20stage%20with%20soft%20golden%20haze%20and%20silhouette%20of%20a%20young%20performer%2C%20warm%20coral%20and%20cream%20tones%2C%20editorial%20moody%20lighting%2C%20high%20detail%2C%20cinematic%20photography&width=1600&height=900&seq=hero-chencheng&orientation=landscape",
    lead: "这个故事从一句“我们尊重彼此选择”开始，也在同一句文案里结束。但夹在这两句之间的 21 天，藏着足以改写双方命运的所有细节。",
    overview: [
      "9 月 1 日，选秀节目《声光之上》收官，选手程澈以断层票数拿下总冠军，单曲上线首日播放量即突破两千万。几乎所有声音都在告诉他：属于你的时代来了。",
      "然而聚光灯外的合约却成为第一道裂缝。据多方信源交叉印证，程澈在夺冠前 48 小时才第一次完整看到三年长约的补充条款，其中包括高额违约金与 IP 权益归属细则。",
      "夺冠当晚的庆功直播里，程澈一句“有些决定我希望自己做”被网友逐帧解读，成为整个事件的第一枚引爆点。随后经纪公司深夜回应“欢迎沟通”，措辞克制，但两家粉丝的攻防战已然开打。",
      "真正的转折发生在 9 月 11 日。程澈工作室（疑似由本人控制的账号）发文列举了三大争议条款，并晒出未签字的合同封面；经纪公司随即公布此前双方沟通的聊天截图，舆论进入罗生门阶段。",
    ],
    timeline: [
      { time: "09-01", title: "夺冠封神，人气登顶", text: "程澈以总冠军身份结束赛程，单曲《破晓》上线即空降各大榜单首位。" },
      { time: "09-02", title: "庆功直播表态", text: "一句“希望自己做决定”被解读为不满信号，热度开始攀升。" },
      { time: "09-04", title: "合约争议浮现", text: "多家媒体援引知情人士报道长约附加条款与高额违约金细节。" },
      { time: "09-07", title: "经纪公司首次回应", text: "公司发声明表示合约公开透明，呼吁“以事实为准”。" },
      { time: "09-11", title: "工作室晒合同开撕", text: "列出三大争议条款并展示未签封面，舆论导向发生反转。" },
      { time: "09-16", title: "聊天记录流出", text: "公司公开沟通记录，双方各执一词，第三方下场评理。" },
      { time: "09-21", title: "和解官宣落幕", text: "双方共同声明解约，细节保密，程澈成立个人厂牌。" },
    ],
    analysis: [
      {
        title: "为什么舆论会反复反转？",
        text: "核心在于“信息差”的投放节奏。夺冠时释放的完美形象与夺冠后迅速出现的合约争议形成强烈对比，公众对“被辜负的才华”天然同情，但公司随后放出的记录又制造了第二重悬念，两套叙事互相拉扯，评论自然呈现钟摆式摆动。",
      },
      {
        title: "经纪公司到底输在哪？",
        text: "并非输在法律条文，而是输在节奏感。事件发酵最凶的黄金 48 小时里，公司选择沉默而非正面回应，等热度见顶后再解释，受众早已带着结论去选择相信，迟到的澄清很难抵消先入为主的情绪。",
      },
      {
        title: "三方博弈的真实结构",
        text: "表面上只有艺人与公司两方，实际还包括平台、粉丝后援会与资本。冠军的资源倾斜涉及平台分成，后援会掌握着组织化的舆论动员能力，资本则在观望——任何一方的动作都会改变另外两方的策略，这也是事件迟迟难落地的深层原因。",
      },
    ],
    truthTitle: "所谓“背后真相”，更接近一场公开的议价",
    truthText: [
      "把碎片化爆料拼合后可以看到：这起解约在商业逻辑上早有过招的痕迹。违约金数额与平台分成比例，几乎都与市场同类案例存在可比区间；而所谓“深夜决裂”，更像是谈判破裂后的一拍两散。",
      "真相不一定非黑即白，而是一方想体面离开、另一方想守住筹码的拉扯。对吃瓜者而言，最有价值的不是站队，而是看懂这套“和解经济学”。",
    ],
    conclusion:
      "程澈事件提醒我们：一夜爆红从来不是终点，而是更复杂游戏的入场券。当光环褪去、条款摊开，每个人都要为自己的选择付学费——明星如此，公司亦然。",
  },
  {
    id: "live-sales-script",
    title: "顶流主播“助农翻车”：一场精心编排的流量剧本如何穿帮",
    hotTitle: "助农直播“剧本门”",
    category: "网红塌房",
    tag: "直播乱象",
    heat: 93,
    views: "221万",
    comments: "2.9万",
    published: "2026-09-04",
    readingMin: 9,
    author: "深度解析组",
    excerpt:
      "一场号称“为农户止损”的助农直播，被扒出背景板、供应商与哭诉剧情全是安排，镜头前的一滴眼泪，最终成了流量生意的最后一块遮羞布。",
    cover:
      "https://readdy.ai/api/search-image?query=messy%20modern%20live%20streaming%20studio%20with%20tripod%20cameras%20ring%20lights%20and%20crates%20of%20fruit%2C%20dramatic%20contrast%20between%20bright%20screen%20glow%20and%20dark%20corners%2C%20warm%20amber%20and%20deep%20green%20tones%2C%20editorial%20documentary%20photography&width=1600&height=900&seq=hero-livefraud&orientation=landscape",
    lead: "当镜头里的眼泪被证实是剧本，公众愤怒的其实不是“卖货”，而是被当作提线木偶的欺骗感。",
    overview: [
      "9 月上旬，一位粉丝量过千万的主播打起“助农”旗号，在直播间声泪俱下地讲述果农滞销困境，号召粉丝“爱心下单”，三小时带货近 500 万。",
      "但很快有眼尖网友发现端倪：直播间背景板上的“合作社”名称，与三个月前一则同样“助农剧本”视频里的布景完全一致；所谓“滞销果园”，供应商地址竟是城区批发市场。",
      "随着更多取证视频流出，事件被系统扒皮。主播团队先删视频后发长文道歉，称“叙事需要艺术加工”，但评论区几乎一边倒地喊打。",
    ],
    timeline: [
      { time: "09-03", title: "催泪助农直播上线", text: "主播讲述滞销故事，实时销量飙升，冲上带货榜第一。" },
      { time: "09-04", title: "布景穿帮被扒", text: "网友对比历史视频发现背景板与供应商信息前后矛盾。" },
      { time: "09-05", title: "连续实锤流出", text: "批发市场价格、库存照片等证据陆续公开，热度爆表。" },
      { time: "09-06", title: "团队删除视频", text: "相关切片遭批量删除，进一步刺激网友取证传播。" },
      { time: "09-07", title: "公开道歉回应", text: "团队承认“还原失真”，宣布退款并停播整改。" },
    ],
    analysis: [
      {
        title: "为何“助农”成了流量密码？",
        text: "助农自带道德光环，能显著降低用户的下单防御心理。用真实产业背书，再叠加“我亏本也要帮”的话术，转化率往往远高于普通带货，正是这种甜头让部分团队铤而走险。",
      },
      {
        title: "评论区为何一边倒？",
        text: "公众反感的不是卖货本身，而是被操纵的共情。当用户发现自己的善心成了点击率、自己的爱心成了 GMV 时，背叛感会迅速转化为群体性的道德审判，平台机制又会把这种情绪推向热搜。",
      },
    ],
    truthTitle: "这不是一次失误，而是一次成本极低的投机",
    truthText: [
      "从布景复用、话术模板到供应商链条，都指向这是一套可复制、可批量化操作的成熟打法。对幕后团队而言，翻车的“退货运费险”和“道歉公关”都是计入成本的前置预算——只要翻车概率可控，这就是门稳赚的生意。",
    ],
    conclusion:
      "剧本穿帮撕开的，是整个直播行业“信任透支”的一角。平台、从业者与监管都需要重新回答同一个问题：当共情可以量产，我们还能凭什么相信镜头？",
  },
  {
    id: "variety-script-gate",
    title: "综艺“剧本门”事件：观众为何为一个剪辑镜头集体破防",
    hotTitle: "综艺剧本剪辑争议",
    category: "综艺内幕",
    tag: "剪辑争议",
    heat: 88,
    views: "197万",
    comments: "2.2万",
    published: "2026-09-02",
    readingMin: 8,
    author: "事件梳理组",
    excerpt:
      "一档观察类综艺因“恶意剪辑”被卷入舆论风暴，嘉宾的剪辑顺序、后期字幕甚至 BGM 都被逐帧分析，观众用显微镜宣告：我们再也不是被牵着走的观众。",
    cover:
      "https://readdy.ai/api/search-image?query=video%20editing%20timeline%20on%20large%20monitor%20with%20playback%20controls%20and%20clapperboard%20in%20dim%20production%20suite%2C%20warm%20coral%20screen%20glow%2C%20cream%20and%20amber%20tones%2C%20behind%20the%20scenes%20editorial%20photography&width=1600&height=900&seq=hero-varietyscript&orientation=landscape",
    lead: "一次看似普通的“谁更体贴”排序，却点燃了整季积压的不满。当剪辑成为塑造人设的工具，观众的反抗也随之而来。",
    overview: [
      "《屋檐下的我们》是一档主打真实生活的观察综艺，开播三季口碑稳定。但在 9 月最新一期中，节目组通过调整几位嘉宾的发言顺序，营造出某位嘉宾“冷漠刻薄”的观感，引发当事人粉丝抗议。",
      "事态升级源于一段未播片段。有观众从花絮与正片的接缝处扒出，嘉宾原话的完整语境被截断，字幕也被放大引导，原本善意的玩笑在顺序重排后显得极具攻击性。",
      "节目官微随后承认“叙事节奏处理不够审慎”，但仅删除争议片段、未做公开道歉，此举进一步点燃舆论。多家媒体下场评论“剪辑伦理”，事件从粉丝圈层扩散为行业议题。",
    ],
    timeline: [
      { time: "09-01", title: "正片引发争议", text: "某嘉宾发言顺序被指断章取义，相关词条冲上热搜。" },
      { time: "09-02", title: "花絮片段打脸", text: "网友复原完整语境，剪辑争议有了实证。" },
      { time: "09-03", title: "官方删片回应", text: "节目组承认节奏问题，删除片段却未道歉，舆论反弹。" },
      { time: "09-05", title: "业内集体讨论", text: "剪辑师与媒体人发声，讨论“恶意剪辑”边界。" },
    ],
    analysis: [
      {
        title: "剪辑如何“制造”人设？",
        text: "综艺的本质是把几十小时素材压缩成几十分钟故事，素材选择即价值观选择。导演组通过排序、配乐、字幕和镜头反应的取舍，完全可以在不造假的情况下重塑一个人的形象——这正是“剪辑魔法”让观众最不安的地方。",
      },
      {
        title: "观众为何越来越难被糊弄？",
        text: "因为观众手里也有“剪辑权”。花絮、探班直播、多机位素材在粉丝群体中被快速重组比对，官方叙事与民间叙事一旦冲突，前者往往因“动机存疑”而败下阵来。",
      },
    ],
    truthTitle: "真正的冲突是“叙事主导权”之争",
    truthText: [
      "节目组想用冲突留住观众，观众却想夺回对真相的定义权。这次破防的本质，是受众第一次在工业级叙事面前集体说“不”，而它可能改写未来真人秀的剪辑逻辑。",
    ],
    conclusion:
      "当观众开始逐帧检视，综艺的“真实感”就再也不能靠技术糊弄。对内容方而言，尊重素材的完整性，远比制造一时的冲突更高明。",
  },
  {
    id: "fandom-control",
    title: "饭圈“控评”风波：一场关于圈地与表达的持久战",
    hotTitle: "饭圈控评攻防战",
    category: "饭圈观察",
    tag: "圈层文化",
    heat: 82,
    views: "164万",
    comments: "1.8万",
    published: "2026-08-30",
    readingMin: 7,
    author: "深度解析组",
    excerpt:
      "一条普通行业新闻下方的评论区，竟被数千条模板化留言“洗版”。当点赞、控评与反黑成为标准动作，路人表达的空间被压缩到只剩沉默，一场关于公共表达边界的讨论就此展开。",
    cover:
      "https://readdy.ai/api/search-image?query=overhead%20view%20of%20a%20wall%20covered%20with%20colorful%20sticky%20notes%20and%20polaroid%20photos%20of%20fans%20tributes%2C%20mixed%20warm%20pink%20and%20melon%20green%20accents%2C%20layered%20organic%20texture%2C%20editorial%20documentary%20style%20photography&width=1600&height=900&seq=hero-fandom&orientation=landscape",
    lead: "控评看似只是粉丝的自发行为，实则是一套高度组织化的数字劳动体系。它保护了什么，又挤占掉了什么？",
    overview: [
      "事情的起因很小：某财经账号发布了一条关于行业薪资的中性报道，评论区却迅速被某偶像粉丝的模板化安利占据，与报道内容毫无关联。路人多次留言被“前排控评”压下去后，愤怒情绪开始发酵。",
      "随后，粉丝组织内部的一段“控评排班表”流出，详细到每个时段、每条文案的点赞数要求，被网友戏称为“评论区施工队”。原本的零星抱怨，因此升级为对饭圈组织化控评的系统性质疑。",
      "争议中也有另一种声音：有粉丝解释，控评是为了“保护偶像不被恶意攻击”，是多年被打压后的防御机制。两派观点在网络上一度激烈碰撞，折射出圈层文化下的表达困境。",
    ],
    timeline: [
      { time: "08-27", title: "路人吐槽被淹", text: "新闻评论区被无关安利占领，路人心态炸裂。" },
      { time: "08-28", title: "排班表流出", text: "组织化控评细节曝光，“评论区施工队”词条走红。" },
      { time: "08-29", title: "两派大讨论", text: "支持与反对声音互相碰撞，平台评论区论战升级。" },
      { time: "08-30", title: "平台下场引导", text: "相关新闻获平台标记，讨论转向圈地边界议题。" },
    ],
    analysis: [
      {
        title: "控评到底在“保护”什么？",
        text: "对粉丝而言，控评是应对外部恶意的集体防御，是圈层内认同感的来源；但对圈外人而言，它是对公共讨论空间的批量占领。同一套动作，在两种语境下有着完全相反的正当性。",
      },
      {
        title: "为什么“路人”越来越沉默？",
        text: "因为表达需要成本。面对上千条整齐划一的留言，零星的真话显得既微弱又突兀，多数路人会选择“划走”而非“开麦”，最终形成声音越来越大的假象与真实沉默的反差。",
      },
    ],
    truthTitle: "控评的终点，是所有人的表达都失真",
    truthText: [
      "当评论区被模板填满，真假评价的边界开始模糊，商业数据与人气的可信度同步贬值。这次风波表面是粉丝与路人的冲突，深层却是整个“点赞经济”正在为透支的公信力买单。",
    ],
    conclusion:
      "无论是粉丝还是路人，都需要重新校准表达的尺度：真正的热爱不需要靠淹没别人来证明，健康的圈子，也容得下不同的声音。",
  },
  {
    id: "corporate-apology",
    title: "企业“道歉函”舆情：危机公关的两天三夜全复盘",
    hotTitle: "企业危机公关复盘",
    category: "商界八卦",
    tag: "舆情应对",
    heat: 76,
    views: "138万",
    comments: "1.1万",
    published: "2026-08-26",
    readingMin: 11,
    author: "事件梳理组",
    excerpt:
      "从一条员工朋友圈发酵到全国热搜，一家估值百亿的消费品牌，用三天时间经历了从“甩锅实习生”到“董事长鞠躬”的完整危机，成为今年最值得拆解的公关反面教材。",
    cover:
      "https://readdy.ai/api/search-image?query=press%20conference%20desk%20with%20microphones%20and%20empty%20chairs%20facing%20audience%20in%20a%20modern%20boardroom%2C%20cool%20screen%20light%20with%20warm%20coral%20accent%20lights%2C%20tense%20corporate%20atmosphere%2C%20editorial%20newsroom%20photography&width=1600&height=900&seq=hero-crisis&orientation=landscape",
    lead: "道歉不是越早越好，也不是越多越好。真正决定成败的，是危机发生后的那 72 小时里，企业做出了多少个错误选择。",
    overview: [
      "8 月 20 日晚，一则疑似该品牌员工的吐槽截图流出，内容涉及产品质量与内部管理，被转发后登上热搜。次日，品牌官微发布声明，将事件定性为“个别员工不实言论”，并暗示已启动内部处理。",
      "这份“甩锅式回应”彻底点燃舆论。消费者开始翻旧账，供应链爆料接踵而至，品牌三天内市值蒸发数十亿。眼看事态失控，公司于 8 月 22 日由董事长亲自直播鞠躬道歉，并宣布成立整改委员会。",
      "复盘整个链条会发现：第一封回应并非公关失误，而是对舆论情绪的严重低估；真正致命的是它把“问题员工”放在“问题产品”前面，触发了公众最敏感的价值神经。",
    ],
    timeline: [
      { time: "08-20", title: "截图流出", text: "员工吐槽内容被搬运扩散，相关词条登录热搜榜单。" },
      { time: "08-21", title: "甩锅式声明", text: "官方将矛头指向个人，质疑消费者，舆情全面爆发。" },
      { time: "08-22", title: "旧账被翻", text: "产品质量与供应链问题连环曝光，股价剧烈波动。" },
      { time: "08-22晚", title: "董事长鞠躬", text: "直播道歉并宣布整改，舆论开始出现分化。" },
      { time: "08-24", title: "热度回落", text: "整改清单公布后热度逐步降温，但信任修复遥遥无期。" },
    ],
    analysis: [
      {
        title: "第一封声明为何是“自杀式”回应？",
        text: "因为它回答了没人问的问题，却回避了最关键的价值追问。公众真正在意的是“产品能不能信”，品牌却在争辩“员工能不能管”。当组织试图用切割个人来保全整体，反而让整体显得更加可疑。",
      },
      {
        title: "道歉有没有“黄金公式”？",
        text: "不是道歉的字数或速度，而是顺序与对象。正确顺序应该是先承认价值层面的失误、再说明技术层面的补救，先向受影响者道歉、再向公众交代。本次事件恰恰把顺序完全颠倒。",
      },
    ],
    truthTitle: "危机公关的本质，是价值排序的公开考试",
    truthText: [
      "消费者翻旧账、媒体找素材、员工看风向——所有人其实都在等待品牌回答一个问题：在利益与责任面前，你究竟把谁放在前面？这个问题的答案，早在危机爆发前就已写好，公关只是把它暴露出来而已。",
    ],
    conclusion:
      "两天三夜的危机，教会所有企业的不是话术，而是敬畏：真正的护城河从来不是漂亮的声明，而是日常经营里每一次对消费者的诚实。",
  },
  {
    id: "old-news-revival",
    title: "旧闻“考古”登顶热搜：一条三年前的视频为何突然爆红",
    hotTitle: "旧闻考古热现象",
    category: "社会热议",
    tag: "热搜机制",
    heat: 71,
    views: "112万",
    comments: "9400",
    published: "2026-08-22",
    readingMin: 6,
    author: "深度解析组",
    excerpt:
      "一条三年前的采访片段，在毫无预兆的情况下被“考古”冲上热搜第一。旧闻重映的背后，是算法、情绪与集体记忆共同作用的奇妙化学反应。",
    cover:
      "https://readdy.ai/api/search-image?query=old%20film%20projector%20casting%20warm%20light%20beam%20onto%20a%20stack%20of%20vintage%20photographs%20and%20newspapers%20on%20a%20desk%2C%20nostalgic%20golden%20amber%20and%20cream%20tones%2C%20dreamy%20editorial%20photography&width=1600&height=900&seq=hero-archaeology&orientation=landscape",
    lead: "在信息过载的时代，旧闻的“爆”往往比新闻更值得研究，因为它的出现本身就是一次关于大众情绪的温度计读数。",
    overview: [
      "8 月中旬，一条拍摄于三年前的普通人物采访，因某位博主的一句评价被重新转发，随即在算法推荐下持续滚动，最终登顶热搜。原视频中的主角甚至没有更新动态，却成了当天的“全民话题”。",
      "网友一边刷一边感慨“以前竟然没看过”，一边默契地开始逐句解读，赋予这条旧闻远超其原始含义的“预言式”解读，评论区成为新一轮二次创作现场。",
      "媒体随后分析发现，这类“考古爆火”并非偶发：当现实情绪与某段旧内容高度共鸣时，旧闻便会被算法当作情绪载体重新分发，形成一波“延迟热搜”。",
    ],
    timeline: [
      { time: "08-16", title: "博主一句点评", text: "某博主转发三年前采访并附评语，播放量开始爬坡。" },
      { time: "08-17", title: "算法接力推荐", text: "同类用户反复互动，旧闻播放量一夜破千万。" },
      { time: "08-18", title: "登顶热搜第一", text: "全民考古，逐句解读成为新的二创狂欢。" },
      { time: "08-20", title: "媒体下场分析", text: "“延迟热搜”机制被科普，现象本身成为新闻。" },
    ],
    analysis: [
      {
        title: "旧闻为何会“突然”爆红？",
        text: "旧闻本身没有变化，变化的是当下的社会情绪。当某个集体情绪找不到新的出口时，算法会敏锐地把历史上相似的内容重新推送到前台——看似随机，实则精准。",
      },
      {
        title: "“考古”热意味着什么？",
        text: "它既是集体记忆的修复，也是一种逃避式消费——在信息过剩却缺乏新意的阶段，人们更愿意回头咀嚼那些自带确定性结尾的旧故事，以获得稀缺的安全感。",
      },
    ],
    truthTitle: "热搜上的不是旧闻，而是当下的我们自己",
    truthText: [
      "一段三年前的视频能登顶，说明它精准击中了此刻多数人的某根神经。与其说我们在围观一段旧闻，不如说我们在旧闻里辨认自己的情绪，这或许才是“考古热”最真实的原因。",
    ],
    conclusion:
      "每一次旧闻重燃，都是一次时代情绪的集体回响。学会读懂热搜背后的人群心理，比单纯追逐新瓜更能帮助我们理解这个正在加速变化的世界。",
  },
  {
    id: "star-split-pr",
    title: "当红艺人分手官宣：一场关于体面与流量的公关范本",
    hotTitle: "顶流情侣体面官宣分手",
    category: "娱乐圈",
    tag: "感情八卦",
    heat: 63,
    views: "86万",
    comments: "7600",
    published: "2026-08-18",
    readingMin: 6,
    author: "事件梳理组",
    excerpt:
      "没有撕扯、没有声明互揭，两位顶流用一份措辞克制的联合官宣结束恋情，却意外把分手本身变成了教科书级公关现场，也让吃瓜群众看懂了体面背后的博弈。",
    cover:
      "https://readdy.ai/api/search-image?query=two%20silhouettes%20walking%20apart%20on%20a%20softly%20lit%20evening%20street%20with%20warm%20lamplight%20and%20gentle%20bokeh%2C%20moody%20romantic%20yet%20melancholic%20atmosphere%2C%20cream%20and%20coral%20tones%2C%20editorial%20photography&width=1600&height=900&seq=hero-star-split&orientation=landscape",
    lead: "当一对曾经甜到发齁的顶流情侣同时按下“体面键”，我们该惊讶的不是分手，而是这则官宣为何如此滴水不漏。",
    overview: [
      "两人自公开恋情以来一直备受关注，同款、合体综艺与品牌合作不断，粉丝也从“唱衰”逐渐转为“入股”。正因如此，8 月中旬那则同步发布的联合声明才显得格外突兀。",
      "声明全文不到两百字，却精准覆盖了感情结束、彼此祝福、工作不受影响、恳请尊重隐私四层信息，几乎没有给营销号留任何发挥空间。随后双方工作室各自转发，口径完全一致。",
      "就在网友感慨“体面”时，商业端开始密集动作：早前绑定两人的代言陆续发布单线物料，综艺切片被陆续下架。业内分析认为，这次官宣的节奏，其实是商业团队数月准备的产物。",
    ],
    timeline: [
      { time: "08-10", title: "共同出席活动显疏离", text: "两人同框互动明显减少，外界首次察觉异样信号。" },
      { time: "08-13", title: "联合声明上线", text: "同步发布分手官宣，措辞克制体面，热搜瞬间引爆。" },
      { time: "08-14", title: "商务端集中调整", text: "双人代言拆分为单线物料，此前合作综艺陆续撤档。" },
      { time: "08-16", title: "热度平稳回落", text: "因口径统一、信息留白，事件未演变为连续剧式撕扯。" },
    ],
    analysis: [
      {
        title: "“体面”为什么是门生意？",
        text: "对顶流而言，分手的公开方式直接影响商业价值。一份无过错、无撕扯的声明能最大程度保全双方路人缘与代言合约，因此越是高热度情侣，越需要提前准备“分手预案”。",
      },
      {
        title: "给吃瓜者留的空白",
        text: "声明刻意回避了分手原因，这种留白既是保护隐私，也是博弈艺术——真相一旦细节化，就容易翻车，而模棱两可才能让各自粉丝都找到满意的解释。",
      },
    ],
    truthTitle: "体面背后，是长达数月的高管会议",
    truthText: [
      "从时间节点与商业动作的严丝合缝来看，这场官宣更接近团队精密排练的结果，而非一时冲动。对粉丝而言，最值得读懂的或许是：在流量时代，连“告别”都要被当作一场需要管理舆情的项目。",
    ],
    conclusion:
      "这场分手教会我们，明星关系的公开与否早已不只是两个人的事。当我们习惯用“公关”拆解一切时，也别忘了体面之下，真实的心情同样存在。",
  },
  {
    id: "food-vlogger-fake",
    title: "探店博主“排队神话”崩塌：镜头前的烟火气为何都是假的",
    hotTitle: "探店博主假排队翻车",
    category: "网红塌房",
    tag: "探店乱象",
    heat: 59,
    views: "71万",
    comments: "5200",
    published: "2026-08-14",
    readingMin: 7,
    author: "深度解析组",
    excerpt:
      "一间平日里门可罗雀的小店，为何在短视频里永远排着长队？当“演员路人”与“临时雇来的老板”被一一对号，探店这条产业链的滤镜，终于被一把扯了下来。",
    cover:
      "https://readdy.ai/api/search-image?query=empty%20tiny%20street%20food%20stall%20with%20steam%20rising%20in%20front%20of%20blurred%20crowd%20mannequins%20in%20background%2C%20contrast%20between%20fake%20hustle%20and%20real%20quiet%2C%20warm%20amber%20and%20cream%20tones%2C%20documentary%20editorial%20photography&width=1600&height=900&seq=hero-food-fake&orientation=landscape",
    lead: "排队是探店视频最有效的“食欲钩子”。可当排队本身被产业化，镜头里的烟火气，就成了被批量生产、明码标价的剧本。",
    overview: [
      "一位主打“人间烟火”的百万粉探店博主，某天被发现其常驻的一家面馆“生意惨淡”。网友顺藤摸瓜，扒出视频中的长队多是付费群演，老板也是按场次结算的“演员”，连店内好评都是批量生成。",
      "随着更多探店号的“神店”被逐一点名，一个更系统的链条浮出水面：流量机构会先低成本包下空置档口，再用假排队与夸张标题包装成“排队神店”，最后通过加盟费变现。",
      "事件发酵后，平台下架相关视频并回应将加强“体验型内容”的审核，博主本人道歉称“为了还原氛围”。但这场翻车撕开的，是整个探店赛道的信任危机。",
    ],
    timeline: [
      { time: "08-08", title: "反差被网友发现", text: "某博主力荐的面馆被拍到店门冷清，质疑开始积累。" },
      { time: "08-10", title: "群演自曝", text: "多位自称临时演员的用户晒出兼职记录与出镜画面。" },
      { time: "08-11", title: "机构链条被扒", text: "包店、雇排队、引流的加盟套路被系统梳理曝光。" },
      { time: "08-13", title: "博主道歉整改", text: "删除争议视频，平台加强体验型内容审核。" },
    ],
    analysis: [
      {
        title: "“排队”为什么屡试不爽？",
        text: "从众心理是食欲最强的催化剂。镜头里等半小时才能吃上的画面，会向观众传递“这家店一定很值得”的潜台词，从而显著拉高点击与到店转化，这正是它被商业化的原因。",
      },
      {
        title: "信任塌方后的代价",
        text: "当观众发现推荐可被购买，整个探店赛道都会为个案背锅。长期来看，真正受损的是那些靠真实口碑经营的小店——它们将更难在人人设防的环境里被看见。",
      },
    ],
    truthTitle: "这不只是博主的错，而是系统性的流量生意",
    truthText: [
      "假排队背后，往往站着包店机构、群演中介与招商加盟的完整利益链。整治探店乱象不能只靠博主自觉，更需要平台从账号认证、真实探店打卡到处罚机制上的多方联动。",
    ],
    conclusion:
      "当烟火气可以被编造，我们失去的不只是一家被捧红的“假神店”，更是对真实评价的基本信任。下一碗面端上来前，不妨先问一句：镜头那头的队伍，是真的吗？",
  },
];

